module.exports = __webpack_public_path__ + "img/game-a.3667ce27.svg";